import React from 'react'
import './style.css'
import { Link } from 'react-router-dom'
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { useTheme } from '@material-ui/core/styles';
import * as ROUTES from '../../constants/routes';
//import logoImage from '../../HackMakers_Logo_White_medium.png'
import logoImage from '../../HM-Full-White-v3.png'
import { withFirebase } from '../Firebase';


const SidebarNavBase = (props) => {
    const theme = useTheme();

    const drawerStyle = {
        backgroundColor: '#333333',
        height: '100%'
    }
    
    const logoStyle = {
    paddingLeft: '10px',
    width: '80%'
    }
      
    const container = props.window !== undefined ? () => window().document.body : undefined;

    const drawer = (
        <div style = {drawerStyle}>
          <div style={{padding: '10px'}} />
          <img src = {logoImage} style = {logoStyle} alt="logo"/>
          {/* <Divider /> */}
        <div>
          <List>
                <Link className = "menu-item" key="1"  to = {ROUTES.USER_DASHBOARD}>
                  <ListItem button><ListItemText primary="Dashboard" /></ListItem>
                </Link>
                <Link className = "menu-item" key="2" to = {ROUTES.RESOURCE_CENTER}>
                  <ListItem button><ListItemText primary="Resource Center" /></ListItem>
                </Link>
                <a className = "menu-item" key="3" href="//forms.gle/kthTNAAQr1zpgjfL9" target="_blank" rel="noopener noreferrer">
                  <ListItem button><ListItemText primary="Team and Submissions" /></ListItem>
                </a>
                <a className = "menu-item" key="5" href="//hackmakers.com/#faq" target="_blank" rel="noopener noreferrer">
                  <ListItem button><ListItemText primary="FAQ" /></ListItem>
                </a>
                <a className = "menu-item" key="6" href="//digitaldefencehack.slack.com/" target="_blank" rel="noopener noreferrer">
                  <ListItem button><ListItemText primary="#DigitalDefence Hack SLACK" /></ListItem>
                </a>
          </List>
    
          {/* <Divider /> */}
    
              {/* Registered/Unregistered Section */}
    
          {/* <List>
              <Link to = "/" className = "menu-item">
                <ListItem button>
                  <ListItemText>Registered/Unregistered</ListItemText>
                </ListItem>
              </Link>
          </List>
    
          <Divider /> */}
      
          <List className = "secondary-nav-new">
            <Link className = "menu-item" key ="1" to = {ROUTES.DASHBOARD}>  
              <ListItem button><ListItemText primary="HOME" /></ListItem>
            </Link>
            <Link className = "menu-item" key ="2" to ={ROUTES.LANDING}>  
              <ListItem button><ListItemText primary="SIGN OUT" onClick={props.firebase.doSignOut}/></ListItem>
            </Link>
          </List>
          </div>
        </div>
      );


    return (
        <nav className={props.classes.drawer} aria-label="mailbox folders">
        <Hidden smUp implementation="css">
          <Drawer
            container={container}
            variant="temporary"
            anchor={theme.direction === 'rtl' ? 'right' : 'left'}
            open={props.mobileOpen}
            onClose={props.handleDrawerToggle}
            classes={{
              paper: props.classes.drawerPaper,
            }}
            ModalProps={{
              keepMounted: true, // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Hidden>
        <Hidden xsDown implementation="css">
          <Drawer
            classes={{
              paper: props.classes.drawerPaper,
            }}
            variant="permanent"
            open
          >
            {drawer}
          </Drawer>
        </Hidden>
      </nav>
    );
}


export default withFirebase(SidebarNavBase);
  